import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

/**
 * Renders the out-of-office notice resolved by useOutOfOfficeNotice as the last item in
 * the message list. A blocking notice means nobody on the thread can receive the message
 * and the caller hides the composer alongside it, so it announces itself; otherwise it is
 * a quiet heads-up about who is away and the composer stays.
 */
export default function ThreadNotice({ notice }) {
  if (!notice) return null

  const { users, blocking } = notice

  return (
    <Fade in>
      <Stack
        spacing={1}
        sx={styles.notice}
        role={blocking ? 'alert' : 'status'}
        data-testid={blocking ? 'thread-out-of-office-blocked' : 'thread-out-of-office'}
      >
        {users.map((user) => (
          <Line key={user.id} title={`${user.fullName} is out of office`} message={user.outOfOfficeMessage} />
        ))}
      </Stack>
    </Fade>
  )
}

function Line({ title, message }) {
  return (
    <Box sx={{ color: 'text.secondary' }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
      {message && (
        <Typography variant="body2" sx={styles.message}>
          {message}
        </Typography>
      )}
    </Box>
  )
}

const styles = {
  notice: {
    maxWidth: 480,
    mx: 'auto',
    textAlign: 'center',
  },
  message: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}
